function addCart(){
  AT_Main.fixNoScroll();
  $('.cart-sb').toggleClass('opened');
  $('html,body').toggleClass('cart-opened');
}

function notifyAddCartFail($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000,
    position:'center'
  });	
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();

  /* Show loading */
  $('.loading').show();

  var $this = $(this);

  $this.addClass('disabled');

  var form = $this.parents('form');

  // Hide Modal
  $('.modal').modal('hide');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
  
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  
  $('.loading').hide();
  
  
  addCart();
  

  // Get the cart show in the cart box.
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');		
  });
  
  
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

var g = {

      common : {
        init: function(){
          $("body").on( 'click','.add-to-cart', addToCart );
        }
      }
  
      ,templateIndex : {
        init: function(){}
      }

      ,templateProduct : {
        init: function(){}
      }

      ,templateCart : {
        init: function(){}
      }
	}  
    ,u = {
        fire: function(t, a, o) {
            var e = g;
            a = void 0 === a ? "init" : a, "" !== t && e[t] && "function" == typeof e[t][a] && e[t][a](o)
        }
        ,loadEvents: function() {
            var t = document.body.id;
            u.fire("common"), $.each(document.body.className.split(/\s+/), function(a, o) {
                u.fire(o), u.fire(o, t)
            })
        }
    };

$(document).ready(u.loadEvents);

$(document).ready(function(){
  
  $('#gallery-image li.previ-image .thumb-img').click(function(){
    if ($('#product-image .image-selected-product').hasClass('unvisible-product')) {

      $('#product-image .image-selected-product').removeClass('unvisible-product');
      $('#product-image .video-selected-product').addClass('unvisible-product');
      $('.zoomContainer').removeClass('unvisible-product');
      
    } else {
      
    }

  });
  
  $('#gallery-image li.last-video .thumb-img').click(function(){
    if ($('#product-image .video-selected-product').hasClass('unvisible-product')) {

      $('#product-image .video-selected-product').removeClass('unvisible-product');
      $('#product-image .image-selected-product').addClass('unvisible-product');
      
      $('.zoomContainer').addClass('unvisible-product');
      
      var video = document.getElementById("myVideo");
      
      video.play();
      
    } else {
    
    }

  });

  
});



// $(document).on("click","#gallery-image .previ-image", function(e){
  
//   if ($('#product-image .image-selected-product').hasClass("unvisible-product")) {
  
//   } else {
 
//     $('#product-image .image-selected-product').addClass('unvisible-product');
//     $('#product-image .video-selected-product').removeClass('unvisible-product');
    
//   }
//   e.preventDefault();
  
// });
// $(document).on("click","#gallery-image .last-video", function(e){
  
//   if ($('#product-image .video-selected-product').hasClass("unvisible-product")) {
  
//   } else {
 
//     $('#product-image .image-selected-product').addClass('unvisible-product');
//     $('#product-image .video-selected-product').removeClass('unvisible-product');
    
//   }
//   e.preventDefault();
  
// });
